import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _find from "lodash/find";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import { CELL_CLASS_DELETE } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var deleteCellClassJsonMerger = function deleteCellClassJsonMerger(cellClasskey) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClasskey, "\")]"),
      value: {
        $remove: true
      }
    }
  }];
};
var deleteCellSet = function deleteCellSet(experimentId, cellClassKey) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error, hierarchy, _find$children$map, _find2, cellSetKeys;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error, hierarchy = _getCellSets.hierarchy;
            if (!(loading || error)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", null);
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"), {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/boschni-json-merger+json'
              },
              body: JSON.stringify(deleteCellClassJsonMerger(cellClassKey))
            });
          case 6:
            cellSetKeys = (_find$children$map = (_find2 = _find(hierarchy, {
              key: cellClassKey
            })) === null || _find2 === void 0 ? void 0 : _find2.children.map(function (_ref2) {
              var key = _ref2.key;
              return key;
            })) !== null && _find$children$map !== void 0 ? _find$children$map : [];
            _context.next = 9;
            return dispatch({
              type: CELL_CLASS_DELETE,
              payload: {
                key: cellClassKey,
                cellSetKeys: cellSetKeys
              }
            });
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteCellSet;